<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-4">
          <c-card title="훈련평가 상세" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col">
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <c-field 
                      :editable="editable"
                      :disabled="disabled"
                      :data="traning"
                      type="dept_user" 
                      label="평가자" 
                      name="evaluationUserId" 
                      v-model="traning.evaluationUserId" />
                  </div>
                </div>
                <div class="row q-pt-sm">
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <c-textarea
                      :editable="editable"
                      :disabled="disabled"
                      label="평가의견"
                      :rows="26"
                      name="evaluationOpinon"
                      v-model="traning.evaluationOpinon">
                    </c-textarea>
                  </div>
                </div>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-8">
          <c-table
            ref="table"
            title="훈련평가항목 목록"
            :columns="grid.columns"
            :data="traning.emergencyTrainingEvaluationModels"
            noDataLabel="훈련구분에 따른 항목이 나옵니다."
            :editable="editable && !disabled"
            :usePaging="false"
            :isExcelDown="false"
            :hideBottom="false"
            rowKey="attendUserId"
          >
            <template slot="table-button">
              <q-btn-group outline >
                <c-btn
                  v-if="!disabled && editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="traning"
                  mappingType="PUT"
                  label="저장"
                  icon="save"
                  @beforeAction="savePlan"
                  @btnCallback="saveCallback" 
                />
                <c-update-btn 
                  name="updateBtn"
                  :data.sync="updateBtnProps.data"
                  :btnEditable.sync="updateBtnProps.btnEditable"
                  :flagCondition.sync="updateBtnProps.flagCondition"
                />
              </q-btn-group>
            </template>
          </c-table>
        </div>
      </div>
    </q-form>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'traning-assess',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopEmergencyTrainingId: '',
      }),
    },
    traning: {
      type: Object,
      default: () => ({
        sopEmergencyTrainingId: '',
        plantCd: '',
        trainingName: '',
        eapTrainingTypeCd: null,
        checkPurpose: '',
        trainingStartDate: '',
        trainingStartTime: '',
        trainingEndDate: '',
        trainingEndTime: '',
        emergencyPlanName: '',
        summary: '',
        trainingWay: '',
        trainingArea: '',
        trainingInstructUserIds: [],
        sopEmergencyPlanId: '',
        trainingScenarioNo: '',
        evaluationUserId: '',
        evaluationOpinon: '',
        trainingCompleteFlag: 'N',
        regUserId: '',
        chgUserId: '',  

        emergencyTrainingUsersModels: [],
        emergencyTrainingEvaluationModels: [],

        // 훈련시나리오 
        trainingScenarioName: '',
        preRequisites: '',
        materials: '',
        indirectNotice: '',
        directlyNotice: '',
        trainingContentsOutline: '',
        trainingContentsSummary: '',
        revisionNum: '',
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    updateBtnProps: {
      type: Object,
      default: () => ({
        data: {
          title: '훈련',
          flag: false,
        },
        flagCondition: false,
        btnEditable: false,
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
        height: '460px'
      },
      editable: true,
      isSave: false,
      getItemUrl: '',
      saveUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.getItemUrl = selectConfig.sop.eap.training.plan.getItem.url;
      this.saveUrl = transactionConfig.sop.eap.training.plan.item.save.url
      // code setting
      // list setting
      this.setHeader();
    },
    setHeader() {
      this.$comm.getComboItems('EAP_TRAINING_POINT_CD', false).then(_result => {
        this.grid.columns = [
          {
            name: 'evaluationItemName',
            field: 'evaluationItemName',
            label: '평가항목',
            align: 'left',
            style: 'width:400px',
            sortable: false,
          },
          {
            setHeader: true,
            name: 'evaluationPointCd',
            field: 'evaluationPointCd',
            label: '점수',
            align: 'center',
            style: 'width:100px',
            sortable: false,
            type: 'select',
            comboItems: _result
          },
          {
            name: 'remark',
            field: 'remark',
            label: '비고',
            align: 'left',
            style: 'width:300px',
            sortable: false,
            type: 'text'
          },
        ]
      });
      this.getData();
    },
    getData() {
      this.$http.url = this.getItemUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        sopEmergencyTrainingId: this.traning.sopEmergencyTrainingId,
        trainingTypeCd: this.traning.eapTrainingTypeCd,
        plantCd: this.traning.plantCd,
        useFlag: 'Y',
      }
      this.$http.request((_result) => {
        this.traning.emergencyTrainingEvaluationModels = _result.data;
      },);
    },
    savePlan() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.traning.chgUserId = this.$store.getters.user.userId

              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('getDetail')
      this.getData();
    },
  }
};
</script>